import Axios from '../../../networking/intraceptor';
import {
	pharmacy_birthday_context,
	pharmacy_birthday_dob,
	pharmacy_birthday_quote,
	pharmacy_birthday_reminder,
	pharmacy_birthday_wishes
} from '../../../networking/urlEndPoints';

export const fetchBirthdayContext = async () => {
	return Axios.get(pharmacy_birthday_context);
};

export const updateBirthdayDob = async (dob) => {
	return Axios.post(pharmacy_birthday_dob, { dob });
};

export const deferBirthdayDobPrompt = async (remindInDays) => {
	return Axios.post(pharmacy_birthday_reminder, { remind_in_days: remindInDays });
};

export const fetchBirthdayQuote = async (userId) => {
	return Axios.get(pharmacy_birthday_quote, { params: { user_id: userId } });
};

export const sendBirthdayWish = async ({ recipientUserId, message }) => {
	return Axios.post(pharmacy_birthday_wishes, {
		recipient_user_id: recipientUserId,
		message,
	});
};
